import { twMerge } from 'tailwind-merge';
export function cx(...classes) {
    return twMerge(classes.filter(Boolean));
}
//# sourceMappingURL=cx.js.map